export var Frequency;
(function (Frequency) {
    Frequency["Daily"] = "daily";
    Frequency["Monthly"] = "monthly";
    Frequency["Weekly"] = "weekly";
})(Frequency || (Frequency = {}));
//# sourceMappingURL=data-export-frequency.js.map